import { render, staticRenderFns } from "./AppointmentPartnerCompanies.vue?vue&type=template&id=757c02c7"
import script from "./AppointmentPartnerCompanies.vue?vue&type=script&lang=ts"
export * from "./AppointmentPartnerCompanies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports